export default {"src":"/_next/static/media/0xa1faa113cbe53436df28ff0aee54275c13b40975.a1198f3a.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};